// style
import { IconBrandInstagram, IconBrandTelegram, IconBrandWhatsapp } from '@tabler/icons-react';
import './style/footer.css'
import { Link, NavLink } from 'react-router';
import { RoutesClient } from '../../features/routes/routes';
const Footer = () => {
    return (
        <>
            <footer className=" bg-footer py-5 pb-md-3 pb-5">
                <section className="container">
                    <div className="row">
                        <div className="col-lg-3 text-md-start text-center">
                            <Link to="/">
                                <img src={require('./../../assets/media/logo/logo.png')} alt="logo" className="brand-logo" />
                            </Link>
                            <p className='mb-0 text-md-start text-center text-white mt-3'>
                                -
                                تهران-فردوسیه شهریار-بلوار امیرکبیر-بلوار امام خمینی-پلاک 1015
                            </p>
                            <p className='mb-0 text-md-start text-center text-white mt-3'>
                                -
                                شماره تماس :09127657763
                            </p>
                            <div className="social d-flex text-white justify-content-md-start justify-content-center mt-3">
                                <Link to={'https://instagram.com/ariya.steel.rad'} className='text-white text-decoration-none'>
                                    <IconBrandInstagram size={25} />
                                </Link>
                                <Link to={'https://t.me/ariyasteelrad'} className='text-white text-decoration-none'>
                                    <IconBrandTelegram size={25} className=' mx-3' />
                                </Link>
                                <Link to={'https://wa.me/+989906332606'} className='text-white text-decoration-none'>
                                    <IconBrandWhatsapp size={25} className='me-3' />
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-3 text-lg-start text-center d-lg-inline-block d-none ps-5">
                            <h6 className='text-white  h5 fw-bold'>لینک های مفید</h6>
                            <ul className='list-group px-0'>
                                {RoutesClient.map((link) => (
                                    <>
                                        {link.show && link.footer === true ? (
                                            <li className='list-group-item px-0'>
                                                <>
                                                    <NavLink className="text-white text-decoration-none" to={link.address}>
                                                        {link.label}
                                                    </NavLink>
                                                </>
                                            </li>
                                        ) : null}
                                    </>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-3 d-lg-inline-block d-none ps-5">
                            <h6 className='text-white h5 fw-bold'>تماس با ما</h6>
                            <ul className='list-group px-0'>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://t.me/ariyasteelrad'}>
                                        تلگرام
                                    </NavLink>
                                </li>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://wa.me/+989906332606'}>
                                        واتساپ
                                    </NavLink>
                                </li>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://instagram.com/ariya.steel.rad'}>
                                        اینستاگرام
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3 d-lg-inline-block d-none ps-5">
                            <h6 className='text-white h5 fw-bold'>جواز ها</h6>
                            <div className='bg-white rounded rounded-4 p-3' style={{ width: '135px' }}>
                                {/* @ts-ignore */}
                                <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=328773&amp;Code=9m3l7KnWZkQ6Ynha2mcB" rel="noreferrer">
                                    {/* @ts-ignore */}
                                    <img referrerPolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=328773&amp;Code=9m3l7KnWZkQ6Ynha2mcB" alt="" style={{ cursor: 'pointer', width: '100px', height: '100px', objectFit: 'cover' }} code="9m3l7KnWZkQ6Ynha2mcB" data-lazy-src="https://trustseal.enamad.ir/logo.aspx?id=328773&amp;Code=9m3l7KnWZkQ6Ynha2mcB" data-ll-status="loaded" class="entered lazyloaded" />
                                    <noscript>
                                        {/* @ts-ignore */}
                                        <img referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=328773&Code=9m3l7KnWZkQ6Ynha2mcB' alt='' style={{ cursor: 'pointer', width: '100px', height: '100px', objectFit: 'cover' }} code='9m3l7KnWZkQ6Ynha2mcB' />
                                    </noscript>
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="connection-box text-center py-3 pb-2 mt-3">
                        <p className='text-white font-medium mb-5 mb-md-0'>
                            © ۱۴۰۵ . کلیه حقوق مادی و معنوی وب‌سایت متعلق به آریا استیل راداست.                        </p>
                    </div>
                </section>
            </footer>
        </>
    )
}

export default Footer;